module.exports = __webpack_public_path__ + "img/fourtune-brands.3514c746.jpg";